import React, { useState } from "react";
import { HeaderButtonSection, HeaderButtonText } from "./styles";
import HeaderDropdown from "./HeaderDropdown";
import { useHeaderBtn } from "@app/hooks/stateStore/headerButton";

interface IProps {
  label: string;
  onPress?: () => void;
  data?: any;
  notIcon?: boolean;
  style?: any;
}

const HeaderButton = ({
  label,
  onPress,
  data,
  notIcon,
  style = {},
}: IProps) => {
  const { data: headerBtn, mutate } = useHeaderBtn();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [hoverState, setHoverState] = useState(false);

  if (headerBtn?.hoverState === undefined) {
    mutate({
      hoverState: false,
    });
  }

  return (
    <HeaderButtonSection
      hover={headerBtn?.hoverState}
      onClick={onPress}
      onMouseOut={() => setHoverState(false)}
      onMouseOver={() => {
        mutate({
          hoverState: true,
        });
        setHoverState(true);
      }}
    >
      {/* Dropdown */}
      <HeaderDropdown data={data} />
      <HeaderButtonText style={{ ...style }}>{label}</HeaderButtonText>
      {/* {!notIcon ? (
				<View style={{ marginLeft: 3 }}>
					{hoverState ? (
						<IconCaretUp size={12} stroke={5} />
					) : (
						<IconCaretDown size={12} stroke={5} />
					)}
				</View>
			) : null} */}
    </HeaderButtonSection>
  );
};

export default React.memo(HeaderButton);
